import React, { useState } from "react";
import { ViewMoreFeedback } from "../../pages";
import { MimaToastUtil } from "../../components";
import constant from "../../utils/constant";
import { FeedbackController } from "../../controllers";
import * as yup from "yup";

const ViewMoreFeedbackContainer = ({ data, closeModal }) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = () => {
    return yup.object().shape({
      reason: yup.string().required("Enter reason"),
    });
  };

  const onSubmit = async (payload) => {
    setLoading(true);

    const { status, errorMessage } =
      await FeedbackController.updateFeedbackStatus(payload, data._id);
    if (status === constant.Success) {
      setLoading(false);
      closeModal();
      MimaToastUtil.success({
        message: constant.Success,
      });
    } else {
      MimaToastUtil.error({
        message: errorMessage,
      });
    }
    setLoading(false);
    return;
  };

  return (
    <ViewMoreFeedback
      onSubmit={onSubmit}
      data={data}
      closeModal={closeModal}
      validationSchema={validationSchema}
    />
  );
};
export default ViewMoreFeedbackContainer;
